interface Props { status?: string; statusFormatted?: string; className?: string; }

const COLORS: Record<string, string> = {
    PROCESSING: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
    COMPLETED: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    COMPLETED_WITH_FAILURES: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
};

const RegistrationBatchStatusBadge = ({ status, statusFormatted, className = '' }: Props) => {
    if (!status) return <span className="text-gray-400">—</span>;
    const color = COLORS[status] || COLORS.PROCESSING;
    return <span className={`inline-block whitespace-nowrap px-2 py-0.5 rounded text-[10px] font-medium ${color} ${className}`}>{statusFormatted || status}</span>;
};

export default RegistrationBatchStatusBadge;
